const pathConstant = {
    SIGNIN : '/sign-in',
    LOGOUT: '/logging-out',
    FORGOT_PASSWORD : '/forgot-password',
    CHANGE_PASSWORD : '/change-password',
    DASHBOARD : '/',
    MANAGE_USERS : '/manage-users',
    MANAGE_DEPARTMENTS : '/manage-departments',
    MANAGE_JDL : '/manage-jdl',
    USER_ATTENDANCE : '/attendance',
    FORMAT_CV : '/format_cv',
    REQUIREMENTS : '/requirements',
    REQUIREMENTS_DETAILS : '/requirements/details/:id/:company/:position_title/',
    HR_MANAGEMENT_EMPLOYEE_DATA : '/hr-management/employee-data',
    HR_MANAGEMENT_LEAVE_CREDITS : '/hr-management/leave-credits',
    HR_MANAGEMENT_EXTRACT_REPORT_ATTENDANCE_REPORT : '/hr-management/extract-report/attendance-report',
    LEAVE_TAB : '/attendance/leave',
    LEAVE_APPROVAL : '/hr-management/leave-approval/:token',
    CST_DASHBOARD : '/cst-dashboard',
    CST_REVENUE_TARGET : '/cst/admin/target/revenue',
    CST_RECRUITERS_PIPELINE : '/cst/admin/recruiters-pipeline',
    CDD_PIPELINE : '/cst/cdd-pipeline',
    REVENUE_SUMMARY : '/cst/revenue-summary',
    REVENUE_TRACKER_DASHBOARD : '/cst/revenue-tracker',
    CANDIDATE_PROFILE : '/candidates/cv/profile'
}

export default pathConstant;